import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'

InertiaProgress.init()

createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),
  title: (title) => (title ? `${title} - SOMISALE` : 'SOMISALE'),
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) }).use(plugin)

    app.config.globalProperties.$filters = {
      currency(value) {
        return new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 2 }).format(value) + ' Kč'
      },
      date(value) {
        return new Date(value).toLocaleDateString('cs-CZ', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
      },
      // Put the rest of your filters here
    }

    app.mount(el)
  },
})
